export const getENV = () => {
  return {
    dev: 'https://robin-shop-hxbank.test.yqtb2b.com',
    trial: 'https://robin-shop-hxbank.test.yqtb2b.com',
    release: 'https://shop-hxbank.yqtbuy.com',
    SHOPSN: 'c766a53a',
  }
}
